<template>
  <el-table-column
    prop="ia_code"
    sortable="custom"
    label="IA kód"
    show-overflow-tooltip
    min-width="90"
  >
    <template slot-scope="scope">
      {{ scope.row.ia_code || '-' }}
    </template>
  </el-table-column>
</template>

<script>
  export default {
    propName: 'ia_code',
  };
</script>
